module.exports = __webpack_public_path__ + "static/right-eff163d66216ac5c533ac0374719016b.png";